import React, { useState } from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { comparisonRows } from '../../data/pricingComparison';
import { formatPrice, pricingPlans } from '../../data/pricingPlans';
type MobileComparisonProps = {
  planHref: (planId: string) => string;
  planCta: (planId: string) => string;
};
export function MobileComparison({
  planHref,
  planCta
}: MobileComparisonProps) {
  const [activeIndex, setActiveIndex] = useState(1);
  const plan = pricingPlans[activeIndex];
  return <div className="mt-8 lg:hidden" data-id="element-233" data-mp="2v079cszrilc3">
      <div role="tablist" aria-label="Choose a plan to compare" className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-234" data-mp="2v18r1gbaa62s">
        {pricingPlans.map((item, index) => {
        const isActive = index === activeIndex;
        return <button key={item.id} type="button" role="tab" aria-selected={isActive} onClick={() => setActiveIndex(index)} className={`font-display border px-3 py-2.5 text-xs font-bold uppercase tracking-[0.06em] transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 ${isActive ? 'border-[#041F60] bg-[#041F60] text-white' : 'border-[#A6B6F8]/60 bg-white text-[#3A3A3A] hover:border-[#5B5299]'}`} data-id="element-235" data-mp="1empjpikezafr" data-mpi={index}>
              {item.name}
            </button>;
      })}
      </div>

      <div className="mt-6 border border-stone-200 bg-white" data-id="element-236" data-mp="1wult5hc4dplw">
        <div className="flex items-baseline justify-between gap-3 border-b border-[#A6B6F8]/50 px-5 py-4" data-id="element-237" data-mp="1ww6jeureimdy">
          <div data-id="element-238" data-mp="1i3cy2spg7c1d">
            <p className="text-xs font-bold uppercase tracking-[0.1em] text-[#5B5299]" data-id="element-239" data-mp="1n40u5ssjaj2g">
              {plan.name}
            </p>
            {plan.recommended && <p className="mt-1 text-xs font-bold text-[#041F60]" data-id="element-240" data-mp="196m18e32nt5q">
                Most popular
              </p>}
          </div>
          <p className="text-2xl font-bold tracking-tight text-[#041F60]" data-id="element-241" data-mp="3ftb8bxuq4vur">
            {plan.priceLabel || formatPrice(plan.monthlyPrice)}
            <span className="text-xs font-semibold text-stone-500" data-id="element-242" data-mp="3b0i3zb363pj7"> / mo</span>
          </p>
        </div>

        <dl data-id="element-243" data-mp="36387xcl9wfme">
          {comparisonRows.map((row, index) => {
          const value = row.values[activeIndex];
          return <div key={row.feature} className="flex items-start justify-between gap-4 border-b border-[#A6B6F8]/30 px-5 py-3" style={{
            backgroundColor: index % 2 === 1 ? 'rgba(166,182,248,0.08)' : 'transparent'
          }} data-id="element-244" data-mp="2lzrmx671nts" data-mpi={index}>
                <dt className="text-sm leading-6 text-[#3A3A3A]" data-id="element-245" data-mp="3kr326xexis1l">
                  {row.feature}
                </dt>
                <dd className="shrink-0 pt-0.5 text-right" data-id="element-246" data-mp="2ed3s7r8gkgri">
                  {value === true ? <>
                      <CheckIcon size={17} className="ml-auto text-[#5B5299]" aria-hidden="true" data-id="element-247" data-mp="29f28r574effi" />
                      <span className="sr-only" data-id="element-248" data-mp="trdssshjzbmt">Included</span>
                    </> : value === false ? <>
                      <MinusIcon size={16} className="ml-auto text-stone-300" aria-hidden="true" data-id="element-249" data-mp="12n3jnh1rsy7l" />
                      <span className="sr-only" data-id="element-250" data-mp="1cjga8620qvy4">Not included</span>
                    </> : <span className="text-sm font-bold text-[#041F60]" data-id="element-251" data-mp="1hknmahb72hal">
                      {value}
                    </span>}
                </dd>
              </div>;
        })}
        </dl>

        <div className="px-5 py-5" data-id="element-252" data-mp="3jcigfj1eq352">
          <a href={planHref(plan.id)} className="font-display flex items-center justify-center gap-2 bg-[#041F60] px-4 py-3.5 text-[12px] font-bold uppercase tracking-[0.11em] text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2" data-id="element-253" data-mp="3nc10ydpbgc7d">
            {planCta(plan.id)}
          </a>
        </div>
      </div>
    </div>;
}